export default "__VITE_ASSET__CF7fpOJQ__"